import { render, staticRenderFns } from "./DeclarationGeneral.vue?vue&type=template&id=2cf2812b&"
import script from "./DeclarationGeneral.vue?vue&type=script&lang=ts&"
export * from "./DeclarationGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationGeneral.vue?vue&type=style&index=0&id=2cf2812b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
